import store from "@/store";
import SNACKBAR_TYPES from "@/utils/enum/SNACKBAR_TYPES";
import firebaseService from "@/services/firebase-service";
import i18n from "@/language/i18n";

var MobileDeviceBridgeHandler = (function () {

    var _title;
    var _handler;

    var setUp = function (title, handler) {
        _title = title;
        _handler = handler;

        return executionHandler;
    }

    var executionHandler = (function () {

        var execute = async function () {
            let data = await _handler.invokeNotification();

            try {
                await firebaseService.pushMessage(_title, JSON.stringify(data));
                await _showPushNotificationSuccess();
            } catch (e) {
                await _showPushNotificationError();
            }
        }

        /**
         * Shows Success Snackbar
         *
         * @param {String} message
         * @returns {Promise<any>}
         * @private
         */
        var _showPushNotificationSuccess = (message = i18n.t('MobileDeviceBridge.sentences.sendPushNotification')) => {
            return store.dispatch('globalSnackbarStore/showSnackbarWithMessage', {
                type: SNACKBAR_TYPES.SUCCESS, message
            });
        }

        /**
         * Shows Error Snackbar
         *
         * @param {String} message
         * @returns {Promise<any>}
         * @private
         */
        var _showPushNotificationError = (message = i18n.t('MobileDeviceBridge.sentences.couldNotSendPushNotification')) => {
            return store.dispatch('globalSnackbarStore/showSnackbarWithMessage', {
                type: SNACKBAR_TYPES.ERROR, message
            });
        }

        return {
            execute: execute
        }

    })();

    return {
        setUp: setUp
    }
})();

export default MobileDeviceBridgeHandler;
